export default "__VITE_ASSET__COWbqVzU__"